<template>
  <inline-edit
    :action="route('settings.debt-payment')"
    title="Edit debt payment preferences"
    v-bind="{ user }"
  >
    <l-debt-target-input v-model="user"/>
  </inline-edit>
</template>

<script setup>
import InlineEdit from "@/components/inlines/InlineEdit.vue"
import LDebtTargetInput from "@/components/inputs/LDebtTargetInput.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object })
</script>
